import script from "./PhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneInput.vue?vue&type=script&setup=true&lang=js"

import "./PhoneInput.vue?vue&type=style&index=0&id=2547331d&lang=scss"

const __exports__ = script;

export default __exports__